import React, {useEffect, useState, useCallback} from 'react'
import {Helmet} from 'react-helmet'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'
import {every} from 'lodash'
import {useTranslation} from 'react-i18next'
import {Page, Flex, Button} from 'components'
import {getSubscriptions} from 'payments'
import {fetchClubPaymentSubscriptions as fetchSubscriptions, stopSubscriptionPlans} from 'payments/actions'
import NoPayments from '../NoPayments'
import SubscriptionsTable from '../SubscriptionsTable'
import {getActive} from 'clubs'
import {getCompanyName} from 'app/selectors'
import {Loading} from 'components'

const Subscriptions_Overview = ({
  fetchClubPaymentSubscriptions, 
  club, 
  companyName, 
  clubSubscriptions,
  stopSubscriptionPlans,
  showCreateSubscriptionPlanModal,
  setSubscriptionPlanId,
  subscriptionPlanId
  }) => {
  const [t] = useTranslation()

  useEffect(() => {
    fetchClubPaymentSubscriptions()
  }, [fetchClubPaymentSubscriptions, club])
 
  const stopSubscriptionHandler = useCallback((subscriptionId) => {
    new Promise((resolve, reject) => {
      let parameters = {
        subscriptionId: subscriptionId
      };

      return stopSubscriptionPlans({resolve, reject, values: parameters});
    }).then(() => {
      return new Promise((resolve, reject) => {
        
        return fetchClubPaymentSubscriptions()
      })
    });

  }, [club])

  return (

    <Page>
      <Helmet title={t('Subscriptions | {{companyName}}', {companyName})} />
      {
        clubSubscriptions === null ? <Loading/> :
          every(clubSubscriptions, (clubSubscription) => clubSubscription.length === 0) ? (
            <NoPayments  />
          ) : (
            <SubscriptionsTable 
              subscriptions={clubSubscriptions}
              stopSubscriptionHandler={stopSubscriptionHandler}
              showCreateSubscriptionPlanModal={showCreateSubscriptionPlanModal}
              setSubscriptionPlanId={setSubscriptionPlanId}
              subscriptionPlanId={subscriptionPlanId}
            />
          )      
      }
    </Page>
  )
}

const enhancer = connect(
  createStructuredSelector({
    companyName: getCompanyName,
    clubSubscriptions: getSubscriptions,
    club: getActive,
  }),
  {
    fetchClubPaymentSubscriptions: fetchSubscriptions.requested,
    stopSubscriptionPlans: stopSubscriptionPlans.requested
  }
)

export default enhancer(Subscriptions_Overview)
